var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "permissions" },
    _vm._l(_vm.permissions, function(permission, index) {
      return _c("Permission", { key: index, attrs: { permission: permission } })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }